export const indexItems = [
  { id: 1, name: '明星动态', icon: 'ri-star-line', count: '2,841篇', desc: '明星行程、街拍、恋情、家庭等最新动态追踪' },
  { id: 2, name: '影视资讯', icon: 'ri-film-line', count: '1,963篇', desc: '电影电视剧开机、杀青、定档、票房等影视全链路报道' },
  { id: 3, name: '综艺热点', icon: 'ri-tv-line', count: '1,527篇', desc: '热门综艺节目路透、阵容、赛制、幕后花絮全面覆盖' },
  { id: 4, name: '音乐圈', icon: 'ri-music-line', count: '1,204篇', desc: '新歌发布、演唱会、音乐节、歌手动态一手掌握' },
  { id: 5, name: '时尚前沿', icon: 'ri-shirt-line', count: '986篇', desc: '明星穿搭、红毯造型、品牌代言、时尚活动全解析' },
  { id: 6, name: '八卦深挖', icon: 'ri-search-eye-line', count: '1,158篇', desc: '深度挖掘娱乐圈背后故事，还原事件真相与人物关系' },
  { id: 7, name: '奖项速递', icon: 'ri-trophy-line', count: '743篇', desc: '国内外各大影视音乐颁奖礼提名、获奖名单与现场直击' },
  { id: 8, name: '行业趋势', icon: 'ri-bar-chart-line', count: '612篇', desc: '娱乐产业政策、市场数据、平台动态、资本动向分析' },
  { id: 9, name: '粉丝社区', icon: 'ri-heart-line', count: '3,207篇', desc: '粉丝应援、打榜攻略、偶像动态、同好交流聚集地' },
];